import { Environment } from '@environments/types';

export const environment = {
  // This path is not hard-codes as that wouldn't work with review-apps.
  // oefenen.feature-review-apps.rid-code-monorepo.review.gametailors.com => api.feature-review-apps.rid-code-monorepo.review.gametailors.com
  // oefenen.rid-code.dev.gametailors.com => api.rid-code.dev.gametailors.com
  apiBaseUrl: `https://api.${new URL(location.href).hostname.replace(/^\w+\./, '')}`,
  environment: Environment.DEVELOPMENT,
};
